import { Config } from 'final-form';
import { Form, FormRenderProps } from 'react-final-form';
import { isEqual } from 'lodash';

import { makeZodValidate } from '@occc/ui-forms';

import {
  EngagementChannelConfigFormValues,
  EngagementChannelConfigSchema,
} from '../../common/engagement-channel-config.schema';

type EngagementChannelConfigFormProps = {
  initialValues: EngagementChannelConfigFormValues;
  onSubmit: Config<EngagementChannelConfigFormValues>['onSubmit'];
  renderer: FormRenderProps<EngagementChannelConfigFormValues>['render'];
};

const validate = makeZodValidate(EngagementChannelConfigSchema);

export const validateSync = (values: EngagementChannelConfigFormValues) =>
  EngagementChannelConfigSchema.safeParse(values);

export const EngagementChannelConfigForm = (props: EngagementChannelConfigFormProps) => {
  const { initialValues, onSubmit, renderer } = props;

  return (
    <Form<EngagementChannelConfigFormValues>
      initialValues={initialValues}
      onSubmit={onSubmit}
      render={renderer}
      validate={validate}
      initialValuesEqual={isEqual}
      keepDirtyOnReinitialize
    />
  );
};
